export class SideNavItemModel {
    icon?: string;
    items?: SideNavItemModel[];
    name: string;
    routeUrl?: string;
    appUrl?: string;
    queryParams?: any;
    roles?: string[];
    isSelected?: boolean;
    onlyShowOnCompactScreen?: boolean;
    hideOnCompactScreen?: boolean;
}
